import { IsEmail, IsNotEmpty, IsString, MaxLength, MinLength, IsOptional, IsUUID, IsNumber, IsArray, IsBoolean } from "class-validator";
import { AbilityEditDTO } from '../ability/ability-edit.dto';

export class UserEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    firstName: string;

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    lastName: string;

    @IsNotEmpty()
    @IsEmail()
    email: string;

    @IsNotEmpty()
    @IsBoolean()
    generatePassword: boolean;

    @IsOptional()
    @IsString()
    @MinLength(8)
    @MaxLength(75)
    password: string;

    @IsOptional()
    @IsString()
    verifyPassword: string;

    @IsNotEmpty()
    @IsBoolean()
    enforcePasswordChange: boolean;

    @IsNotEmpty()
    @IsBoolean()
    enforceTwofactor: boolean;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    image: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    phone: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    cellPhone: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    employeeNumber: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    socialSecurityNumber: string;

    @IsNotEmpty()
    @IsNumber()
    role: number;

    @IsOptional()
    @IsNumber()
    salary: number;

    @IsOptional()
    @IsNumber()
    vacationPaid: number;

    @IsOptional()
    @IsNumber()
    vacationUnpaid: number;

    @IsOptional()
    @IsNumber()
    employmentType: number;

    @IsOptional()
    @IsNumber()
    employmentGrade: number;

    @IsOptional()
    @IsUUID()
    stewardFor: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    teams: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    qualifications: Array<string>;

    @IsOptional()
    @IsUUID()
    collectiveAgreement: string;

    @IsOptional()
    @IsArray()
    abilities: Array<AbilityEditDTO>;

}
